import { type PropsWithChildren } from "react";

import * as S from "./OuterField.styled";

export type OuterFieldProps = PropsWithChildren<{
  hasError?: boolean;
}>;

function OuterField(props: OuterFieldProps) {
  const { hasError, children } = props;

  return (
    <S.OutlineWrapper>
      <S.StrokeWrapper $hasError={hasError}>{children}</S.StrokeWrapper>
    </S.OutlineWrapper>
  );
}

export default OuterField;
